import { grayColor } from "assets/jss/material-dashboard-pro-react.js";
import customInputStyle from 'assets/jss/material-dashboard-pro-react/components/customInputStyle';

const customPhoneInputStyle = {
	...customInputStyle,
	wrapper: {},
	dropdown: {
		zIndex: '5700',
	},
	helperText: {
		color: grayColor[0],
		fontSize: '12px',
	},
};

export default customPhoneInputStyle;
